import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { transformIconData } from '../transformers/icon-url';
var TeamLinkIcons = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_, args, context, info) {
    var requestBody, options;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          requestBody = args.teamLinkUrls.map(function (url) {
            return {
              resourceUrl: url
            };
          });
          options = {
            method: 'POST',
            body: JSON.stringify(requestBody)
          };
          return _context.abrupt("return", context.fetch("".concat(context.url.stargateRoot, "/object-resolver/resolve/batch"), options).then(function (res) {
            return res.json();
          }).then(transformIconData));
        case 3:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function TeamLinkIcons(_x, _x2, _x3, _x4) {
    return _ref.apply(this, arguments);
  };
}();
export default TeamLinkIcons;